import { Close } from "@mui/icons-material";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useGetTagsBasedOnCanonicalNames } from "../../hooks";
import { ReactSelectOption } from "../../interfaces";
import { useLazyGetTagGroupsQuery } from "../../redux/services";
import { AddEditTags } from "../../screens/tags/tagListing/addEditTags";
import { IReactSelect, SelectBox } from "../reactSelect";
import { CanonicalKeys } from "./tagsHightlightSelect";

interface ITagsReactSelect extends Omit<IReactSelect, 'options'> {
    id: string;
    canonical_name: CanonicalKeys;
    hideLabel?: boolean;
}

export const TagsReactSelect: React.FC<ITagsReactSelect> = (
    {
        id,
        canonical_name,
        hideLabel = false,
        ...rest
    }
) => {
    const { isLoading, isFetching, options, refetch, isSuccess } = useGetTagsBasedOnCanonicalNames(canonical_name);

    const [getTagGroupBasedOnCanonicalName, { data: allData = { data: [], totalCount: 0 } }] = useLazyGetTagGroupsQuery();

    const { data } = allData;

    const loading = isLoading || isFetching;

    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);

    const handleClose = (newTag?: ReactSelectOption) => {
        if (newTag) {
            rest?.onChange(newTag);
        }
        setOpen(false)
    };

    const groupDetails = options[0] || data[0];

    const selectedTagGroup = groupDetails ? { label: groupDetails.tag_group_name, value: groupDetails.tag_group_id ?? groupDetails._id, _id: groupDetails.tag_group_id ?? groupDetails._id } : undefined;

    useEffect(() => {
        if (canonical_name && options.length === 0 && isSuccess) { 
            getTagGroupBasedOnCanonicalName({ canonical_name }); 
        }
        // eslint-disable-next-line
    }, [canonical_name, isSuccess]);

    return (
        <>
            <SelectBox
                {...rest}
                id={id}
                label={loading ? "Loading..." : hideLabel ? "" : selectedTagGroup?.label ?? canonical_name}
                options={options}
                loading={loading}
                tagGroupProps={{
                    enableTagCreation: true,
                    onTagCreate: handleOpen,
                    selectedTagGroup: selectedTagGroup
                }}
            />

            <Dialog
                key={JSON.stringify(rest?.value)}
                maxWidth={"sm"}
                fullWidth={true}
                open={open}
                onClose={() => handleClose()}
            >
                <>
                    {/* Dialog Title */}
                    <DialogTitle sx={{ textAlign: 'center' }}>Create Tag</DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={() => handleClose()}
                        sx={{
                            backgroundColor: "#fff",
                            border: "none",
                            borderRadius: "5px",
                            cursor: "pointer",
                            outline: "none",
                            transition: "box-shadow 0.3s ease-in-out",
                            ":hover, :focus": {
                                boxShadow: "0px 0px 5px 2px rgba(103, 58, 183, 0.5)",
                            },
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                            width: "25px",
                            height: "25px",
                            marginTop: "10px",
                            marginRight: "11px",
                        }}
                    >
                        <Close />
                    </IconButton>
                </>
                <DialogContent>
                    <AddEditTags isEdit={false} data={null} refetch={refetch} selectedTagGroup={selectedTagGroup} onDialogClose={(newTag) => handleClose(rest?.isMulti ? [...(rest?.value as ReactSelectOption[] ?? []), newTag] : newTag)} />
                </DialogContent>
            </Dialog>
        </>
    )
}
